<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <!-- Title -->
        <span class="ui grey">Home / AOL</span>
        <h2 class="ui primary header">AOL</h2>
      </div>
    </div>

    <!-- <div fxLayout="row" fxLayoutGap="15px">
      <button class="ui small button primary" (click)="newAol()">
        New AOL
      </button>
    </div> -->
  </div>
  <div class="ui divider"></div>
  <div
    fxLayoutAlign="start center"
    fxLayout="row"
    fxLayoutGap="20px"
    class="link"
  >
    <div class="equipment-id">
      <h2 class="ui primary header" style="color: #505050; font-size: 16px">
        Financial Year End:
      </h2>
    </div>
    <div>
      <sui-select
        class="selection"
        [options]="options"
        [(ngModel)]="yearEnd"
        (ngModelChange)="selectedCurr()"
        style="min-width: 4px; text-transform: capitalize"
        [isSearchable]="true"
        #select
      >
        <sui-select-option
          style="text-transform: capitalize"
          *ngFor="let option of select.filteredOptions"
          [value]="option"
        >
        </sui-select-option>
      </sui-select>
    </div>
    <div class="equipment-id">
      <!-- <h2
        (click)="createFinancialEnd()"
        class="ui primary header"
        style="color: #2c6ecb; font-size: 14px"
      >
        Update
      </h2> -->
    </div>
  </div>

  <div [suiCollapse]="!advancedSearchVisible" appMargin marginY="3">
    <div class="ui segment">
      <app-search-filter-null
        [headers]="headers"
        searchName="Invoice"
        (onCancel)="advancedSearchVisible = !advancedSearchVisible"
        (submitSearch)="advancedSearch($event)"
      ></app-search-filter-null>
    </div>
  </div>
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
  </div>
  <!-- <div class="ui segment" style="border-radius: 4px;" appMargin marginT="0"> -->
  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>
  <!-- </div> -->

  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="15px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <div fxFlex="20">Year</div>
      <div fxFlex="15">Network Assessment</div>
      <div fxFlex="15">Non-Network Assessment</div>
      <div fxFlex="15">Documents</div>
      <div fxFlex="15">Submission Status</div>
      <div fxFlex="20"></div>
    </div>

    <app-aol-row
      [department]="s"
      *ngFor="let s of aols"
      (nextPage)="nextPageData($event)"
      (onView)="viewDepartment($event)"
      (onDownload)="download($event)"
    ></app-aol-row>

    <app-no-record-found *ngIf="aols && aols.length < 1"></app-no-record-found>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui labeled button">
            <div class="ui tiny icon button" (click)="getPage(1)">
              <i class="refresh icon"></i>
            </div>
            <a class="ui basic label"> {{ totalItems }} Record(s) </a>
          </div>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="mini"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
